export default {

    /**
   * Открываем модалку помощи, когда выбрали ЖК и хотим пополнить баланс
   *
   * @param {Object} state - state в store
   * @param {String} complexName - Имя ЖК
   */
    POPUP_REFILL(state, complexName) {
        state.popup.isShow = true;
        state.popup.refillComplex = complexName;
    },

    /**
   * Открывает или закрывает модалку помощи
   *
   * @param {Object} state - state в store
   * @param {Boolean} bool - открыть / закрыть модвлку
   */
    POPUP_TOGGLE(state, bool) {
        state.popup.isShow = bool;
        state.popup.refillComplex = '';
    },

    /**
   * Задаем данные о менеджере
   *
   * @param {Object} state - state в store
   * @param {Object} payload
   * @param {String} payload.name - Имя менеджера
   * @param {String} payload.phone - Телефон менеджера
   */
    SET_MANAGER(state, { name, phone }) {
        state.manager.name = name;
        state.manager.phone = phone;
    },
};
